import { useState, useEffect } from 'react';
import axios from 'axios';
import { providersApi, ProviderPublic } from '../services/providers';

export const useNearbyProviders = (limit: number = 6) => {
  const [providers, setProviders] = useState<ProviderPublic[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchNearbyProviders = async () => {
      try {
        setLoading(true);
        const data = await providersApi.getNearbyProviders(limit);
        setProviders(data);
        setError(null);
      } catch (err: unknown) {
        if (axios.isAxiosError(err)) {
          setError(err.message || 'Failed to fetch nearby providers');
          console.error('Error fetching nearby providers:', err);
          console.error('Error response:', err.response?.data);
        } else if (err instanceof Error) {
          setError(err.message || 'An unexpected error occurred');
        } else {
          setError('An unexpected error occurred');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchNearbyProviders();
  }, [limit]);

  return { providers, loading, error };
};
